<template>
  <div class="lc-project-box">
    <strong>联创项目</strong>
    <p>
      注重业务逻辑，实现应用功能，满足客户需求
      <span @click="$router.push('/demand/list')">查看全部 ></span>
    </p>
    <div class="lc-project-list-box">
      <div
        v-for="el in projectList"
        :key="el.id"
        @click="$router.push(`/demand/detail?id=${el.id}`)"
        class="lc-project-list"
      >
        <p>{{ el.name }}</p>
        <div>
          <span v-html="el.summary || el.demandDescribe"></span>
          <p>
            <img src="@/assets/img/jianzhu.png" alt="jianzhu" />{{
              el.companyName || el.purUnitName
            }}
          </p>
          <div>
            预算金额：<span>¥{{ el.fundAmount }}</span>
          </div>
        </div>
        <span class="active" v-if="el.demandStatus === '6'">已定标</span>
        <span v-if="el.demandStatus === '5'">已截止</span>
        <span class="active" v-if="el.demandStatus === '4'">招标中</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDemandPageList } from "@/api/demand";
export default {
  data() {
    return {
      projectList: [],
    };
  },
  mounted() {
    this.loadGetDemandPageList();
  },
  methods: {
    //分页查询
    loadGetDemandPageList() {
      getDemandPageList(
        {
          current: 1,
          size: 6,
        },
        {}
      ).then((res) => {
        this.projectList = res.records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lc-project-box {
  padding: 64px 0;
  width: 1280px;
  margin: 0 auto;
  > strong {
    display: block;
    font-size: 32px;
    line-height: 45px;
    color: #262626;
    text-align: center;
    margin-bottom: 16px;
  }
  > p {
    font-size: 18px;
    line-height: 24px;
    color: #000;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    > span {
      color: #ea0b06;
      margin-left: 12px;
      line-height: 24px;
      cursor: pointer;
    }
  }
  .lc-project-list-box {
    display: flex;
    flex-wrap: wrap;
    .lc-project-list {
      border: 1px solid #e8e8e8;
      width: 410px;
      margin-right: 25px;
      margin-top: 24px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      > p {
        height: 79px;
        line-height: 79px;
        padding: 0 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
        font-size: 18px;
        color: #262626;
        background: url(../../../assets/img/2.0/demandxpbg.png) no-repeat;
        background-size: 100% 100%;
      }
      > div {
        padding: 24px;
        > span {
          display: block;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          margin-bottom: 16px;
          height: 40px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          white-space: normal;
        }
        > p {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          margin-bottom: 40px;
          > img {
            margin-right: 6px;
          }
        }
        > div {
          display: flex;
          align-items: flex-end;
          font-size: 12px;
          color: #595959;
          line-height: 26px;
          > span {
            font-size: 24px;
            color: #ea0b06;
            line-height: 33px;
          }
        }
      }
      > span {
        display: block;
        height: 63px;
        background: #fafbfc;
        line-height: 63px;
        font-weight: bold;
        font-size: 20px;
        color: #bfbfbf;
        text-align: center;
        &.active {
          color: #36bf8a;
        }
      }
    }
  }
}
</style>
